<script>

    import { toast } from 'bulma-toast'
    import { shipmentsStore, modalStore } from '../stores'
    import ProvidersMethods from '../$methods/providers.methods'

    import ShipmentsService from '../$services/shipments.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import Search from '../$components/input.search.svelte'
    import Select from '../$components/select.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'

    let loading = false
    let metadata = {}

    let query = {
        admin: true,
        page: 0,
        find: null,
        created: -1,
        year: '',
        trackingStatus: '',
    }

    getShipments()

    async function getShipments(reset = false) {

        if(reset === true)
            query.page = 0

        if(query.find)
            query.find = query.find.trim()

        loading = true
        const resp = await ShipmentsService.getShipments(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        metadata = resp.data.metadata
        shipmentsStore.set(resp.data.shipments)
    }

    function setStatus(status) {

        if(query.trackingStatus === status)
            query.trackingStatus = ''
        else
            query.trackingStatus = status

        getShipments(true)
    }

</script>

<Table
    items={ $shipmentsStore.length }
    total={ metadata.total }
    { loading }
    skeletonCols={7}
    bind:metadata
    bind:page={ query.page }
    on:change={ getShipments }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={() => getShipments(true)} />
            <ButtonModal modalId="shipments_report_modal" text="Reporte" icon="file-download" />
        </div>
        <div class="header-bottom">
            <div class="filter-pills">
                <button type="button" class="filter-pill" class:is-active={query.trackingStatus === ''} on:click={() => setStatus('')}>Todos</button>
                <button type="button" class="filter-pill" class:is-active={query.trackingStatus === 'Guía generada'} on:click={() => setStatus('Guía generada')}>Guía generada</button>
                <button type="button" class="filter-pill" class:is-active={query.trackingStatus === 'En camino'} on:click={() => setStatus('En camino')}>En camino</button>
                <button type="button" class="filter-pill" class:is-active={query.trackingStatus === 'Entregado'} on:click={() => setStatus('Entregado')}>Entregado</button>
                <button type="button" class="filter-pill" class:is-active={query.trackingStatus === 'Cancelado'} on:click={() => setStatus('Cancelado')}>Cancelado</button>
                <button type="button" class="filter-pill" class:is-active={query.trackingStatus === 'Finalizado'} on:click={() => setStatus('Finalizado')}>Finalizado</button>
            </div>
            <div class="header-selects">
                <Select
                    bind:value={ query.partner }
                    on:change={ getShipments }
                    text="Partner"
                    size="small"
                    options={ProvidersMethods.getPartners().map(item => ({ value: item, text: item }))}
                />
                <Select
                    bind:value={ query.provider }
                    on:change={ getShipments }
                    text="Proveedor"
                    size="small"
                    options={ProvidersMethods.getProviders().map(item => ({ value: item, text: item }))}
                />
                <Select
                    bind:value={ query.month }
                    on:change={ getShipments } 
                    size="small"
                    text="Mes"
                    options={[
                        {value: '0', text: 'Enero'},
                        {value: '1', text: 'Febrero'},
                        {value: '2', text: 'Marzo'},
                        {value: '3', text: 'Abril'},
                        {value: '4', text: 'Mayo'},
                        {value: '5', text: 'Junio'},
                        {value: '6', text: 'Julio'},
                        {value: '7', text: 'Agosto'},
                        {value: '8', text: 'Septiembre'},
                        {value: '9', text: 'Octubre'},
                        {value: '10', text: 'Noviembre'},
                        {value: '11', text: 'Diciembre'},
                    ]}
                />
                <Select
                    bind:value={ query.year }
                    on:change={ getShipments }
                    size="small"
                    text="Año"
                    options={[
                        {value: '2025', text: '2025'},
                        {value: '2026', text: '2026'},
                    ]}
                />
            </div>
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Usuario</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Servicio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Precio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <span on:click={() => { query.created = query.created * -1; getShipments() }} class="icon pointer" style="cursor:pointer; margin-left: 0.25rem;">
                        <i class="fas fa-sort"></i>
                    </span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $shipmentsStore as shipment, index}
            <tr class:is-tracing={ DateMethods.isAfter12(shipment.tracing? shipment.tracing.updated : null) }>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                <td>
                    <div class="td-stack">
                        <div>{ shipment.user.name }</div>
                        <small>{ shipment.user.email }</small>
                    </div>
                </td>
                <td>
                    <div class="td-stack">
                        <div>{ shipment.provider } · { shipment.service }</div>
                        <div><span class="tag">{ shipment.order.package.volumetric }Kg</span> · <span class="tag">{ shipment.partner || shipment.provider }</span></div>
                    </div>
                </td>
                <td>
                    <div class="td-stack">
                        <div>{ TranslateMethods.get(shipment.pricing.paymentType) }</div>
                        <small>${ shipment.pricing.finalPrice }</small>
                    </div>
                </td>
                <td>
                    <div class="td-stack">
                        <div>{ shipment.trackingStatus }</div>
                        <small>{ shipment.order.delivery.state }</small>
                    </div>
                </td>
                <td>{ DateMethods.dateTimeLarge(shipment.created) }</td>
                <td>
                    <Button on:click={() => modalStore.open('shipment', 'modal', shipment)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>

<style>
    .is-tracing {
        background: lavender;
    }
</style>
